import api from '../../plugins/api';

const processDocument = (chunkId) => {
  return api.post('/api/bank/process-documents', { chunkId });
};

export default processDocument;
